import GameImage from './GameImage.container';

export default GameImage;
